import { render, staticRenderFns } from "./OrganizationDetailsFormVatId.vue?vue&type=template&id=28efa80b&scoped=true&"
import script from "./OrganizationDetailsFormVatId.vue?vue&type=script&lang=ts&"
export * from "./OrganizationDetailsFormVatId.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationDetailsFormVatId.vue?vue&type=style&index=0&id=28efa80b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28efa80b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28efa80b')) {
      api.createRecord('28efa80b', component.options)
    } else {
      api.reload('28efa80b', component.options)
    }
    module.hot.accept("./OrganizationDetailsFormVatId.vue?vue&type=template&id=28efa80b&scoped=true&", function () {
      api.rerender('28efa80b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/forms/OrganizationDetailsFormVatId.vue"
export default component.exports